import $ from 'jquery';
import { Cookie } from '../utilities';

$('.cookie-notice__button').on('click', () => {
    $('.cookie-notice').fadeOut();
    Cookie.set('cookiePolicyConfirmed', 1, false, 365);
});
